import React, { useState, useEffect } from 'react';
import '../css/searchRequset.scss';
import SearchIcon from '@mui/icons-material/Search';
import { getRequest } from '../request';
import getReq from '../interface/getRequestinterface';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

function AdminSearchRequest() {
    const navigate = useNavigate();
    const [requestNumber, setRequestNumber] = useState('');
    const searchRequest=async()=>{
        const response:getReq= await getRequest(`${process.env.REACT_APP_BASE_URL}/Form/UserInfoAdmin/${requestNumber}`) as getReq;
        if(!response.error){
            localStorage.setItem('requestType',JSON.stringify(response.data));
        }
        const data:getReq = await getRequest(`${process.env.REACT_APP_BASE_URL}/Account/GetRequest/${requestNumber}`) as getReq;
        if(!data.error){
            localStorage.setItem('requestDetails',JSON.stringify({userName:data.data.customer,requestNumber:requestNumber}) );
            navigate(`/RequestDetails/${requestNumber}`);
        }else{
            toast.error(data.error);
        }
    }
    const handleBtnSelect=(e)=>{
        if(e.key === 'Enter'){
            searchRequest();
        }
    }
    
  return (
    <div className='background'>
        <div style={{display:'flex',justifyContent:'center',marginTop:'5rem'}}>
            <div className="SearchCard">
                <div className="SearchCardInner">
                    <label className='label'>شماره سفارش مورد نظر را جستجو کنید</label>
                    <div className="SearchContainer">
                        <div className="Icon" onClick={searchRequest}>
                            <SearchIcon/>
                        </div>
                        <div className="InputContainer">
                            <input className='SearchInput' placeholder="شماره سفارش" onChange={e=>setRequestNumber(e.target.value)} onKeyDown={(e)=>handleBtnSelect(e)}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default AdminSearchRequest